export const CustomerChatbotApiRoute = {
  Login: '/cockpit-api/customer-chatbots/login',
} as const;
